export default __webpack_public_path__ + "static/media/fellowship.cbf071b5.svg";